exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.approval-content[data-v-390fe552] {\n  text-align: center;\n  font-weight: 400;\n  padding: 10px 30px;\n}\n.list-container[data-v-390fe552]{\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  text-align: start;\n  margin: auto;\n  padding: 14px 0;\n}\n.list-container ul[data-v-390fe552], .list-container li[data-v-390fe552]{\n  list-style: unset !important;\n}\n", ""]);

// exports
